/**
 * В API `moduleSlug` для реестра — строка (как и для новостей: кастомные модули со своим слагом).
 * Здесь — только встроенный слаг модуля «Реестр» / сторонники.
 */
export enum SupporterModuleSlugEnum {
  Supporters = 'supporters',
}
